import React, { useEffect } from "react";
import { Table, Tag, Image } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { useTypedSelector } from "../../store";
import { useDispatch } from "react-redux";
import { getLeavesHistoryRequest } from "../../slices/leave";

// interface LeaveRecord {
//   _id: string;
//   attendanceDate: string;
//   notes: string;
//   code: string;
//   status: string;
//   rejectedNotes: string;
//   document: string;
//   approval: string;
//   requestDate: string;
// }

// const leaveData: LeaveRecord[] = [
//   {
//     _id: "678cb4e253b4ed18d5c36977",
//     attendanceDate: "2025-02-13",
//     notes: "Testing pasti ",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738571953361-1c198c5abad7e50c2f5f8d5109b49948.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T08:39:13.484Z",
//   },
//   {
//     _id: "678cb4e253b4ed18d5c3696f",
//     attendanceDate: "2025-02-05",
//     notes: "1344",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738571045398-63f906a60dd9880d54bfa351ac983503.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T08:24:05.498Z",
//   },
//   {
//     _id: "678cb4e253b4ed18d5c3696e",
//     attendanceDate: "2025-02-04",
//     notes: "Afeh",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738569076898-cbf8f55e403f54434e056594b8c23a01.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T07:51:16.960Z",
//   },
//   {
//     _id: "678cb4e253b4ed18d5c3696c",
//     attendanceDate: "2025-02-02",
//     notes: "1",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738568795281-ad0778aa8757e902febfbba25d8b2ace.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T07:46:35.364Z",
//   },
//   {
//     _id: "678cb4e253b4ed18d5c3696b",
//     attendanceDate: "2025-02-01",
//     notes: "Testing ",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738568675951-2cb583ff3afe52b6af3fc341f3df0dd4.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T07:44:36.021Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c9",
//     attendanceDate: "2025-01-31",
//     notes: "Foto ",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738568532539-7fc0df8daf0dc68e179c156713a8082f.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T07:42:12.620Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c8",
//     attendanceDate: "2025-01-30",
//     notes: "Foto ",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738568382540-7fc0df8daf0dc68e179c156713a8082f.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T07:39:42.612Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c7",
//     attendanceDate: "2025-01-29",
//     notes: "Foto ",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738568247916-7fc0df8daf0dc68e179c156713a8082f.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T07:37:27.988Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c6",
//     attendanceDate: "2025-01-28",
//     notes: "Coba ",
//     code: "CT",
//     status: "approved",
//     rejectedNotes: "Di setujui",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1737897692939-e8440fcb8187bfd20edad9ec0f5e690a.jpg",
//     approval: "DB0001",
//     requestDate: "2025-01-26T13:21:33.000Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c5",
//     attendanceDate: "2025-01-27",
//     notes: "Terimakasih ",
//     code: "CT",
//     status: "review",
//     rejectedNotes: "",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1738568068132-6b12276cc6b2afb5d85ee1d4745a2650.jpg",
//     approval: "DB0001",
//     requestDate: "2025-02-03T07:34:28.277Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c4",
//     attendanceDate: "2025-01-26",
//     notes: "Dfffd",
//     code: "CT",
//     status: "rejected",
//     rejectedNotes: "LG. Sibuk ",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1737897529604-f65387dbaa7dfa15479db1bdb45fb381.jpg",
//     approval: "DB0001",
//     requestDate: "2025-01-26T13:18:49.679Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c1",
//     attendanceDate: "2025-01-23",
//     notes: "Dfffd",
//     code: "CT",
//     status: "rejected",
//     rejectedNotes: "LG. Sibuk ",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1737897529604-f65387dbaa7dfa15479db1bdb45fb381.jpg",
//     approval: "DB0001",
//     requestDate: "2025-01-26T13:18:49.679Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369c0",
//     attendanceDate: "2025-01-22",
//     notes: "Cobalah ",
//     code: "CT",
//     status: "approved",
//     rejectedNotes: "Di setujui",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1737897216487-b45a3eab8fd1949bb8d0a665b8c9eb85.jpg",
//     approval: "DB0001",
//     requestDate: "2025-01-26T13:13:36.583Z",
//   },
//   {
//     _id: "678cb53b53b4ed18d5c369bf",
//     attendanceDate: "2025-01-21",
//     notes: "Cobalah ",
//     code: "CT",
//     status: "approved",
//     rejectedNotes: "Di setujui",
//     document:
//       "https://images-dailygroup.s3.ap-southeast-1.amazonaws.com/pic_1737897216487-b45a3eab8fd1949bb8d0a665b8c9eb85.jpg",
//     approval: "DB0001",
//     requestDate: "2025-01-26T13:13:36.583Z",
//   },
//   // Tambahkan data lainnya...
// ];

const columns = [
  {
    title: "Tanggal Cuti",
    dataIndex: "attendanceDate",
    key: "attendanceDate",
    render: (date: any) => dayjs(date).format("DD MMM YYYY"),
  },
  {
    title: "Catatan",
    dataIndex: "notes",
    key: "notes",
  },
  {
    title: "Kode",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: any) => {
      let color = "blue";
      if (status === "approved") color = "green";
      if (status === "rejected") color = "red";
      return <Tag color={color}>{status.toUpperCase()}</Tag>;
    },
  },
  {
    title: "Dokumen",
    dataIndex: "document",
    key: "document",
    render: (doc: any) => <Image width={50} src={doc} />,
  },
  {
    title: "Tanggal Permintaan",
    dataIndex: "requestDate",
    key: "requestDate",
    render: (date: any) => dayjs(date).format("DD MMM YYYY HH:mm"),
  },
];

const HistoryLeave: React.FC = () => {
  const eid = useParams();
  const dispatch = useDispatch();
  const { leaveData } = useTypedSelector((state) => {
    return { leaveData: state.Leave.histories };
  });

  console.log(eid);
  console.log(leaveData);

  useEffect(() => {
    if (eid) {
      dispatch(getLeavesHistoryRequest(eid.eid) as any);
    }
  }, [eid]);

  return <Table columns={columns} dataSource={leaveData} rowKey="_id" />;
};

export default HistoryLeave;
